document.addEventListener("DOMContentLoaded", function () {
const accordionImgItems = document.querySelectorAll('.block__accordion-with-image-item');
let accordionCurrentIndex = 0;

accordionImgItems.forEach(item => {
  const accordionAnswer = item.querySelector('.block__accordion-with-image-ans');
  // Initially collapse all
  accordionAnswer.style.maxHeight = '0';
  accordionAnswer.style.overflow = 'hidden';
  accordionAnswer.style.transition = 'max-height 0.3s ease';
});

function openAccordion(index) {
  accordionImgItems.forEach((item, i) => {  
    const accordionAnswer = item.querySelector('.block__accordion-with-image-ans');
    if (i === index) {
      accordionAnswer.style.maxHeight = accordionAnswer.scrollHeight + 'px';
      item.classList.add('active'); 
    } else {
      accordionAnswer.style.maxHeight = '0';
      item.classList.remove('active');
    }
  });
}


accordionImgItems.forEach((item, index) => {
  const accordionHeader = item.querySelector('h6');
  accordionHeader.addEventListener('click', () => {
    openAccordion(index);
  });
});

// Auto-open accordion items every 5 seconds
setInterval(() => {
  openAccordion(accordionCurrentIndex);
  accordionCurrentIndex = (accordionCurrentIndex + 1) % accordionImgItems.length;
}, 8000);

// Start with the first item open
openAccordion(0);
});